import { styled } from '../../../../lib/stitches'
import { gray1, gray15, gray8 } from '../../../platform/color'
import { animate } from './utils'

const StyledTable = styled('div', {
  fontFamily: 'DM Sans'
})

const StyledTableHead = styled('div', {
  display: 'flex',
  padding: '12px',
  background: gray1,
  borderBottom: '1px solid rgba(0,0,0,.1)'
})

const StyledTableBody = styled('div')

const StyledTableRow = styled('div', {
  userSelect: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  padding: '12px 12px',
  paddingLeft: '12px',
  '@tablet': {
    paddingLeft: '44px'
  },
  height: '80px',
  borderRadius: '6px',
  position: 'relative',
  transition: 'all 200ms ease',
  color: gray8,
  '&:hover': {
    color: gray15,
    '& #visualizer': {
      opacity: 0.6
    },
    '& #animated': {
      animation: `${animate} 3s infinite alternate linear`
    }
  },
  variants: {
    active: {
      true: {
        boxShadow: '0px 5px 32px -5px #0000001A',
        color: gray15,
        '& #animated': {
          animation: `${animate} 3s infinite alternate linear`
        },
        '& #visualizer': {
          opacity: 1
        }
      }
    }
  }
})

const StyledText = styled('div', {
  fontWeight: 400,
  position: 'relative',
  variants: {
    bold: { true: { fontWeight: 700 } },
    medium: { true: { fontWeight: 500 } },
    size: {
      '12': {
        fontSize: '12px',
        lineHeight: '20px'
      },
      '14': {
        fontSize: '14px',
        lineHeight: '24px'
      }
    },
    link: {
      true: {
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    }
  },
  defaultVariants: {
    size: '12'
  }
})

const StyledTableCol = styled('div', {
  overflow: 'hidden',
  position: 'relative'
})

const Root = StyledTable
const Header = StyledTableHead
const Body = StyledTableBody
const Row = StyledTableRow
const Col = StyledTableCol
const Text = StyledText

export default {
  Root,
  Header,
  Body,
  Row,
  Col,
  Text
}
